import { Link } from "react-router-dom";
import { Compass, Home, Plane } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="not-found-page">
      <Compass className="w-14 h-14 text-primary mx-auto mb-4" />
      <div className="font-mono text-sm tracking-[0.25em] text-muted-foreground mb-2">ERROR 404</div>
      <h1 className="font-heading font-900 text-3xl sm:text-4xl tracking-tight">This page has drifted off the flight path</h1>
      <p className="text-zinc-600 mt-3">
        The page you're looking for doesn't exist or may have moved. Let's get you back on course.
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link to="/" data-testid="notfound-home-link"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary text-white text-sm font-700 hover:bg-blue-700 transition-colors">
          <Home className="w-4 h-4" /> Back to Home
        </Link>
        <Link to="/flight-search" data-testid="notfound-search-link"
          className="inline-flex items-center gap-2 px-5 py-2.5 border border-zinc-300 text-sm font-700 text-zinc-700 hover:border-primary hover:text-primary transition-colors">
          <Plane className="w-4 h-4" /> Flight Smart Search
        </Link>
      </div>
    </div>
  );
}
